import React from "react";
import "./BattryDisplay.css";

const BatteryDisplay = ({ level }: { level: number }) => {
  const safeLevel = Math.min(100, Math.max(0, level));

  const getColor = () => {
    if (safeLevel <= 20) return "#f87171";   // red
    if (safeLevel <= 50) return "#facc15";   // yellow
    return "#4ade80";                        // green
  };

  return (
    <div className="battery-wrapper">
      <div className="battery">
        <div
          className="battery-level"
          style={{
            width: `${safeLevel}%`,
            backgroundColor: getColor(),
          }}
        />
        <span className="battery-text">{safeLevel}%</span>
      </div>
      <div className="battery-cap" />
    </div>
  );
};

export default BatteryDisplay;
